import Typography from '@mui/material/Typography';

export default function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      align="center"
      {...props}
      sx={[
        {
          color: 'text.secondary',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}>
      {`© ${new Date().getFullYear()} TR@NDING PTE. LTD. All rights reserved.`}
    </Typography>
  );
}
